import React from 'react';

import { Page } from '../../../../../shared/ui/Page';
import { PromocodeCreate } from '../containers/PromocodeCreate';

export const PromocodeCreatePage = () => {
    return (
        <Page isBackButton title={'Создание промокода'}>
            <PromocodeCreate />
        </Page>
    );
};
